import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ReturnInvoicesRoutingModule } from './return-invoices-routing.module';
import { ReturnInvoicesComponent } from './return-invoices.component';
import { RouterModule } from '@angular/router';
import { ReturnInvoicesListModule } from './return-invoices-list/return-invoices-list.module';
import { ReturnInvoicesDetailsModule } from './return-invoices-details/return-invoices-details.module';
import { CreateReturnOrderModule } from './create-return-order/create-return-order.module';
import { CreateReturnInvoiceStepperModule } from './create-return-invoice-stepper/create-return-invoice-stepper.module';
import { CreateCreditReturnInvoiceStepperModule } from './create-credit-return-invoice-stepper/create-credit-return-invoice-stepper.module';
import { CreateReturnOrderManualComponent } from './create-return-order-manual/create-return-order-manual.component';
import { CreateReturnOrderManualModule } from './create-return-order-manual/create-return-order-manual.module';

@NgModule({
  declarations: [
    ReturnInvoicesComponent,
  ],
  imports: [
    CommonModule,
    ReturnInvoicesRoutingModule,
    RouterModule,
    ReturnInvoicesListModule,
    ReturnInvoicesDetailsModule,
    CreateReturnOrderModule,
    CreateReturnInvoiceStepperModule,
    CreateCreditReturnInvoiceStepperModule,
    CreateReturnOrderManualModule
  ],
  exports: [ReturnInvoicesComponent]
})
export class ReturnInvoicesModule { }
